import { render, staticRenderFns } from "./AdminUpdateFaq.vue?vue&type=template&id=1886dc97&scoped=true&"
import script from "./AdminUpdateFaq.vue?vue&type=script&lang=js&"
export * from "./AdminUpdateFaq.vue?vue&type=script&lang=js&"
import style0 from "./AdminUpdateFaq.vue?vue&type=style&index=0&id=1886dc97&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1886dc97",
  null
  
)

export default component.exports